import type { DepositCvusTranslations } from "../interfaces/depositCvus";

export const depositCvusTranslations: DepositCvusTranslations = {
  // Page
  page_title: "CVUs de depósito",
  page_subtitle: "Cuentas receptoras para depósitos en pesos argentinos (Argentina)",
  why_banner:
    "Sin un CVU registrado, los depósitos de la organización en Argentina no se pueden atribuir ni acreditar.",
  no_org_prompt: "Selecciona una organización para ver sus CVUs.",

  // Org selector
  org_label: "Organización",
  org_placeholder: "Buscar organización…",
  org_loading: "Cargando organizaciones…",
  org_empty: "No se encontraron organizaciones.",
  org_error: "No pudimos cargar las organizaciones.",
  org_truncated: "Hay más organizaciones de las que se muestran; refina la búsqueda por nombre.",

  // List
  list_title: "CVUs registrados",
  filter_placeholder: "Filtrar por CVU o nota…",
  filter_no_results: "Ningún CVU coincide con el filtro.",
  empty_title: "Sin CVUs registrados",
  empty_description:
    "Registra la primera cuenta receptora para habilitar los depósitos de esta organización en Argentina.",
  error_load: "No pudimos cargar los CVUs de la organización.",
  error_retry: "Reintentar",
  registered_at: "Registrado el",
  note_label: "Nota",
  status_active: "Activo",
  status_inactive: "Inactivo",
  flavor_static: "Estático",
  flavor_dynamic: "Dinámico",
  copy_aria: "Copiar",
  copy_success: "Copiado al portapapeles",

  // Register dialog
  button_register: "Registrar CVU",
  dialog_title: "Registrar CVU de depósito",
  dialog_description: "La cuenta receptora quedará vinculada a la organización seleccionada.",
  dialog_org_label: "Organización",
  dialog_account_label: "CVU",
  dialog_account_placeholder: "0000 0031 0001 0000 0000 01",
  dialog_account_helper: "22 dígitos, sin espacios ni guiones.",
  dialog_note_label: "Nota (opcional)",
  dialog_note_placeholder: "p. ej. CVU receptor principal",
  dialog_cancel: "Cancelar",
  dialog_submit: "Registrar",
  validation_account: "El CVU debe tener exactamente 22 dígitos.",
  hint_already_registered: "Este CVU ya está registrado para esta organización.",
  toast_registered: "CVU registrado",
  toast_already_registered: "Este CVU ya estaba registrado para la organización",
  error_cross_org:
    "Este CVU ya está asignado a otra organización. Un CVU solo puede estar activo en una organización a la vez.",
  error_no_write_permission: "No tienes permiso para registrar CVUs de depósito.",
  error_register: "No pudimos registrar el CVU.",

  // Detail drawer
  drawer_title: "Detalle del CVU",
  drawer_section_details: "Detalles",
  drawer_section_metadata: "Metadatos",
  drawer_id: "ID",
  drawer_reference: "Referencia",
  drawer_created: "Registrado",
  drawer_updated: "Actualizado",
};
